import { VerticaisManager } from "src/components/vendas/VerticaisManager";
import api from 'src/framework/providers/api'
import { IDataResponse } from "src/framework/providers/api";
import { ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { exibeJustificativaValorServico$ } from "src/store/vendas/projetos/store";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { FormProjetoHibridoType, SolucaoSugeridaHibrido } from "src/store/vendas/projetos/hibrido/hibrido.types";
import { ListagemItem } from "../types";
import { TIPO_FATURAMENTO } from "../constants";

const projetosProvider = new ProjetosProvider();

export interface EstruturasGruposSalvar {
  quantidade: number;
  componente_id: number;
  estruturas_grupo_id: number;
  "@remove"?: boolean;
}

export interface ComponentesSalvar {
  componente_id: number;
  categoria_componentes_id: number;
  quantidade: number;
  valor_unitario: number;
  estruturas_grupos?: EstruturasGruposSalvar[];
  "@remove"?: boolean;
}

export interface EquipamentoConsumoSalvar {
  nome: string
  potencia: number;
  quantidade: number;
  horas_uso: number;
  fator_potencia: number;
  relacao_partida: number;
  consumo_diaria: number
}

function formatarComponentesSalvar(items: ListagemItem[]): ComponentesSalvar[] {
  const comps: ComponentesSalvar[] = []
  for (const item of items) {
    comps.push({
      componente_id: Number(item.componente_id),
      categoria_componentes_id: Number(item.categoria_componentes_id),
      quantidade: Number(item.quantidade),
      valor_unitario: Number(item.valor),
  })   
  }
  return comps;
}

function converterParaKw(valor?: number): number {
  return (valor || 0) / 1000;
}

function formatarEstruturasSalvar(items: ListagemItem[]): ComponentesSalvar[] {
  const comps: ComponentesSalvar[] = []

  for (const item of items) {
    const alreadyAddedIndex = comps.findIndex(comp => comp.componente_id === item.componente_id)

    if (alreadyAddedIndex !== -1) {
      comps[alreadyAddedIndex].quantidade = comps[alreadyAddedIndex].quantidade + Number(item.quantidade)

      if (Array.isArray(comps[alreadyAddedIndex].estruturas_grupos)) {
        comps[alreadyAddedIndex].estruturas_grupos?.push({
          "@remove": item["@remove"] || undefined,
          componente_id: Number(item.componente_id),
          estruturas_grupo_id: Number(item.estruturas_grupo_id),
          quantidade: Number(item.quantidade),
        })
        comps[alreadyAddedIndex]["@remove"] = comps[alreadyAddedIndex].estruturas_grupos?.every(item => item["@remove"] === true) ? true : undefined
      } else {
        comps[alreadyAddedIndex].estruturas_grupos = [{
          "@remove": item["@remove"] || undefined,
          componente_id: Number(item.componente_id),
          estruturas_grupo_id: Number(item.estruturas_grupo_id),
          quantidade: Number(item.quantidade),
        }]
        comps[alreadyAddedIndex]["@remove"] = item["@remove"] || undefined
      }
    } else {
      comps.push({
        componente_id: Number(item.componente_id),
        categoria_componentes_id: Number(item.categoria_componentes_id),
        quantidade: Number(item.quantidade),
        valor_unitario: Number(item.valor),
        "@remove": item["@remove"] || undefined,
        estruturas_grupos: [{
          "@remove": item["@remove"] || undefined,
          componente_id: Number(item.componente_id),
          estruturas_grupo_id: Number(item.estruturas_grupo_id),
          quantidade: Number(item.quantidade),
        }]
      })
    }
  }

  return comps
}

const formatSolucaoSugerida = (data: FormProjetoHibridoType): SolucaoSugeridaHibrido => {
  const componentes: {id: number; quantidade: number; categoria_componentes_id: number;}[] = []

  const inversores = data.solucao_calculada.inversores || [];
  const baterias = data.solucao_calculada.baterias || [];
  const acessorios = data.acessorios || [];
  const estruturas = data.estruturas_calculadas || [];
  const moduloSelecionado = data.modulo_selecionado || null;

  if (inversores.length > 0) {
    componentes.push(...inversores.map(item => {
      return {
        id: item.id,
        quantidade: item.quantidade,
        categoria_componentes_id: item.categoria_componentes_id,
      }
    }))
  }

  if (baterias.length > 0) {
    componentes.push(...baterias.map(item => {
      return {
        id: item.id,
        quantidade: item.quantidade,
        categoria_componentes_id: item.categoria_componentes_id,
      }
    }))
  }

  if (acessorios.length > 0) {
    componentes.push(...acessorios.map(item => {
      return {
        id: item.componente_id,
        quantidade: item.quantidade_original || 0,
        categoria_componentes_id: item.categoria_componentes_id,
      }
    }))
  }

  if(estruturas.length > 0){
    componentes.push(...estruturas.map(item => ({
      id: item.componente_id,
      quantidade: item.quantidade_original || 0,
      categoria_componentes_id: item.categoria_componentes_id,
    })))
  }

  if (moduloSelecionado) {
    componentes.push({
      id: moduloSelecionado.componente_id,
      quantidade: moduloSelecionado.quantidade,
      categoria_componentes_id: moduloSelecionado.categoria_componentes_id,
    })
  }

  const fileiras: SolucaoSugeridaHibrido["fileiras"] = data.fileiras?.map((item) => ({
    posicao: item.posicao_modulo?.value || '',
    estrutura_id: item.tipo_estrutura?.value || 0,
    estruturas_grupo_id: item.tipo_estrutura?.estruturas_grupo_id,
    modulos_sequencia: item.quantidade_modulos,
    fileiras_iguais: item.fileiras,
  }))

  const potenciaModulos = Number(moduloSelecionado?.potencia || 0) * Number(moduloSelecionado?.quantidade || 0)

  return {
    componentes,
    fileiras,
    // potencia: data.potencia_desejada,
    // inversor: data.tipo_inversor?.value,
    regiao_id: data.regioes,
    // inversor_tensao: data.tensao_rede?.value,
    // inversor_tipo_conexao: data.numero_fases?.value,
    // tipo_projeto: data.tipo_projeto?.value,
    // fator_perdas: Number(data.fator_perdas || 0),
    // tipo_inversor: data.tipo_inversor?.value,
    tipo_bateria: data.tipo_bateria?.id || 0,
    tensao_saida: data.tensao_saida?.id || 0,
    taxa_descarga: data.taxa_descarga?.id || 0,
    total_carga_equipamentos_kw: data.total_carga_equipamentos_kw,
    total_carga_equipamentos_w: data.total_carga_equipamentos_w,
    potencia_desejada_kw: data.potencia_desejada_kw,
    potencia_desejada_w: data.potencia_desejada_w,
    tipo_ligacao: data.tipo_ligacao?.id || 0,
    consumo_data_inicial: data.consumo_data_inicial ? data.consumo_data_inicial.toISOString() : '',
    consumo_data_final: data.consumo_data_final ? data.consumo_data_final.toISOString() : '',
    consumo_meses: data.consumo_meses,
    modo_potencia: data.modo_potencia,
    potencia_modulos: potenciaModulos,
  }
}

function getEstruturasDimensionado(data: FormProjetoHibridoType): ListagemItem[] {
  return data.estruturas_calculadas?.filter(item => Number(item.quantidade || 0) > 0) || []
}


function formatarComponentes(data: FormProjetoHibridoType): ComponentesSalvar[] {
  const componentes = []

  const moduloSelecionado = data.modulo_selecionado || null
  const inversoresAdicionados = data.solucao_calculada.inversores?.filter(item => Number(item.quantidade || 0) > 0) || []
  const bateriasAdicionadas = data.solucao_calculada.baterias?.filter(item => Number(item.quantidade || 0) > 0) || []
  const acessoriosAdicionados = data.acessorios?.filter(item => Number(item.quantidade || 0) > 0) || []
  const estruturasAdicionadas = getEstruturasDimensionado(data)

  if (moduloSelecionado) {
    componentes.push(...formatarComponentesSalvar([moduloSelecionado]))
  }

  if (inversoresAdicionados.length) {
    componentes.push(...formatarComponentesSalvar(inversoresAdicionados.map(item => ({
      ...item,
      componente_id: item.id,
      valor_unitario: 0,
      valor: 0,
    }))))
  }

  if (bateriasAdicionadas.length) {
    componentes.push(...formatarComponentesSalvar(bateriasAdicionadas.map(item => ({
      ...item,
      componente_id: item.id,
      valor_unitario: 0,
      valor: 0,
    }))))
  }

  if (estruturasAdicionadas.length) {
    componentes.push(...formatarEstruturasSalvar(estruturasAdicionadas))
  }
  
  if (acessoriosAdicionados.length) {
    componentes.push(...formatarComponentesSalvar(acessoriosAdicionados))
  }

  if (!data.isEdit) {
    return componentes?.filter(i => (i?.quantidade > 0 && !i["@remove"]));
  }

  return componentes
}

function formatEquipamentos(data: FormProjetoHibridoType): EquipamentoConsumoSalvar[] {
  const toDestroy = data.cargas_prioritarias?.filter(item => !!item["@remove"] && !!item.id) || []
  const add = data.cargas_prioritarias.filter(item => item["@new"] && !item["@remove"] && !item.id) || []
  const save = data.cargas_prioritarias.filter(item => !item["@new"] && !item["@remove"]) || []

  return [
    ...add.map(item => ({ ...item, id: null })),
    ...toDestroy,
    ...save,
  ]
}

export async function salvarProjetoHibrido(manager: VerticaisManager, id: string | number | undefined, data: FormProjetoHibridoType, usuario: ExtraInfoUsuario, clonarProjeto?: boolean): Promise<IDataResponse>  {
  const moduloSelecionado = data.modulo_selecionado || null
  const potenciaModulosEmWatts = moduloSelecionado ? (moduloSelecionado.quantidade * moduloSelecionado.potencia) : 0
  const potenciaInversoresEmWatts = [...data.solucao_calculada.inversores]?.filter(item => item.quantidade > 0).reduce((acc, curr) => acc + (curr.potencia * curr.quantidade), 0)

  const componentes = formatarComponentes(data)

  const recalcularValor = projetosProvider.confereRecalcular(componentes, data);

  const getValorServico = () => {
    if (!data.revenda_id) return 0;
    if (!data.recebe_servico) return 0
    if (data.revenda && !data.revenda?.segmentos_servico?.includes(data?.segmento?.includes("on") ? "on" : "off") && Number(data.valor_servico || 0) > 0) return 0;
    return data.valor_servico ? Number(data.valor_servico || 0) : 0
  }

  const getJustificativa = () => {
    const exibe = exibeJustificativaValorServico$.getValue();
    if (exibe === undefined) return data.justificativa_valor_servico || null
    return exibe && data.justificativa_valor_servico ? data.justificativa_valor_servico : null
  }

  const payload = {
    editar_projeto: data.isEdit,
    hibrido: true,
    cargas_prioritarias: formatEquipamentos(data),
    cidade_id: data.cidade?.id,
    cliente_proposta: data.cliente_proposta,
    codigo_venda: data.codigo_venda,
    distribuidor_id: data.distribuidor_id,
    email_proposta: data.email_proposta,
    endereco: {
      cidade_id: data.cidade?.id,
      estado_id: data.estado?.id,
    },
    estado_id: data.estado?.id,
    revenda_id: data.revenda?.id || data.revenda_id || null,
    segmento: data.segmento,
    tipo: data.tipo,
    titulo: data.titulo,
    servico: getValorServico() > 0 ? 'revenda' : null,
    valor_servico: getValorServico(),
    latitude: data.latitude || null,
    longitude: data.longitude || null,
    valor_servico_pis_cofins: data.revenda_id && getValorServico() > 0 ? data.valor_servico_pis_cofins : 0,
    vendedor_interno_id: data.vendedor_interno?.value || undefined,
    reativar: data.reativar,
    peso_gerador: data.resultado_calculos?.componentes?.peso_gerador,
    peso_telhado: data.resultado_calculos?.componentes?.peso_telhado,
    justificativa_valor_servico: getJustificativa(),
    valor: data.resultado_calculos?.componentes?.valor || 0,
    valor_projeto: Number(data.resultado_calculos?.componentes?.valor || 0) + Number(data.resultado_calculos?.servicos?.valor_com_pis_cofins || 0),
    solucao_sugerida: formatSolucaoSugerida(data),
    componentes,
    potencia: potenciaModulosEmWatts ? DecimalUtil.toFixed(converterParaKw(potenciaModulosEmWatts), 2) : 0,
    potencia_inversor: converterParaKw(potenciaInversoresEmWatts),
    tipo_faturamento: TIPO_FATURAMENTO[0].value,
  }

  let primaryKey = id || undefined;
  if (primaryKey && recalcularValor) {
    primaryKey += "?recalcular=true";
  }

  if (primaryKey && usuario?.isIntelbras) {
    Object.assign(payload, { editado_admin: true })
  }

  if (primaryKey) {
    if (recalcularValor) {
      primaryKey += "&atualizar_comissoes=true";
    } else {
      primaryKey += "?atualizar_comissoes=true";
    }
  }

  if (clonarProjeto) {
    primaryKey = undefined
 
    return api.post({
      url: "/projetos/clonagem",
      data: {
        ...payload,
        projeto_original_id: id,
        clonar_via_payload: true
      }
    })
  }

  let result = await manager.save({
    row: payload,
    primaryKey: primaryKey
  })

  if (!primaryKey && result.statusCode === 400 && result.data?.[0]?.message.includes("Projeto") && result.data?.[0]?.message.includes("unique")) {
    result = await manager.save({
      row: payload,
      primaryKey: primaryKey
    })
  }

  return result
}